





























import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import {LoraForwarder as LoraForwarderModel} from '@/model/lora/LoraForwarder';

import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
  export default class LoraForwarderSelector extends Mixins<BaseComponent>(BaseComponent) {
    private loraForwardersStore: LoraForwardersStore = getModule(LoraForwardersStore, this.$store);

  @Prop(Object)
    private forwarder!: LoraForwarderModel;

    private selectedForwarder: LoraForwarderModel | null = null;

    private async mounted() {

      try {
        await this.loraForwardersStore.fetchAvailableForwarders();
        this.selectedForwarder = this.loraForwardersStore.ActiveForwarder;
        this.$emit('update:forwarder', this.selectedForwarder);
      } catch (error) {
        Notify.Error(this.logger, `Could not get available forwarders`, error);
      } finally {
        this.setLoaded();
      }
    }
  }
